import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';

import {
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

import {
  ApiBlueprint,
  createApiRef,
  createFrontendModule,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';

import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

const authentikAuthApiRef = createApiRef<
  OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>().with({
  id: 'auth.authentik',
});

const authentikAuthApi = ApiBlueprint.make({
  name: 'authentik',
  params: defineParams =>
    defineParams({
      api: authentikAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',
            title: 'Authentik',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        provider={{
          id: 'authentik-auth-provider',
          title: 'Authentik',
          message: 'Sign in using Authentik',
          apiRef: authentikAuthApiRef,
        }}
      />
    ),
  },
});

const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [authentikAuthApi, signInPage],
});

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    homePlugin,
    searchPlugin,
    navModule,
    homeModule,
    authModule,
  ],
});
